/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// If Gift-wrap checked: start
$( document ).ready(function() {
  if($('.gift-option-wrapper').length > 0){
    var appendPropertiesHtml = '';
    if($('[data-gift-wrap]').is(':checked')){
      appendPropertiesHtml += '<p class="line-item-property__field" style="display: none;">';
      //       appendPropertiesHtml += '<label for="gift-note">Gift Note</label>';
      appendPropertiesHtml += '<textarea id="gift-note" name="properties[Gift Note]" placeholder="Enter multiple gift notes on new line"></textarea>';
      appendPropertiesHtml += '</p>';
      $('.gift-wrap').html(appendPropertiesHtml);
      $('.gift-wrap .line-item-property__field').fadeIn();
      $('.shopify-payment-button').fadeOut();
    }
  }

  else{
    $('.gift-wrap').html('');
    $('.shopify-payment-button').fadeIn();
  }
})
$('[data-gift-wrap]').on('change', function(){
  var appendPropertiesHtml = '';
  if($('[data-gift-wrap]').is(':checked')){
    appendPropertiesHtml += '<p class="line-item-property__field" style="display: none;">';
    //     appendPropertiesHtml += '<label for="gift-note">Gift Note</label>';
    appendPropertiesHtml += '<textarea id="gift-note" name="properties[Gift Note]" placeholder="Enter multiple gift notes on new line"></textarea>';
    appendPropertiesHtml += '</p>';
    $('.gift-wrap').html(appendPropertiesHtml);
    $('.gift-wrap .line-item-property__field').fadeIn();
    $('.shopify-payment-button').fadeOut();
  }
  else{
    $('.gift-wrap').html('');
    $('.shopify-payment-button').fadeIn();
  }
})
 $(document).ready(function() {
    var firstParagraph = $(".slide-para:first-child");
    var remainingParagraphs = $(".slide-para:not(:first-child)");

    $("#readMoreButton").on("click", function() {
      remainingParagraphs.slideToggle();
      $(this).text(function(i, text) {
        return text === "Read More" ? "Read Less" : "Read More";
      });
    });
  });

 $(document).ready(function() {
    // Toggle the visibility of additional content when "Read more" button is clicked
    $('#toggleButton').click(function() {
      $('.SectionHeader__Description h2:not(:first-of-type), .SectionHeader__Description h3, .SectionHeader__Description p:not(:first-of-type)').slideToggle();
      
      // Change button text based on the visibility of additional content
      if ($(this).text() === 'Read more') {
        $(this).text('Read less');
      } else {
        $(this).text('Read more');
      }
    });
  });


// $(document).ready(function () {
//     // Function to check the window width and add the class accordingly
//     function checkWindowSize() {
//         var windowWidth = $(window).width();
//         var scrollPosition = $(window).scrollTop();
//         var pageHeight = $(document).height();
//         var scrollThreshold = pageHeight * 0.1;

//         // Select both buttons by their classes
//         var button1 = $('.shopify-payment-button__button');
//         var button2 = $('.ProductForm__AddToCart');
        
//         // Check if the window width is less than 900 pixels
//         if (windowWidth < 900) {
//             // Check if the scroll position is past the 10% threshold
//             if (scrollPosition > scrollThreshold) {
//                 // Add the class to both buttons
//                 button1.addClass('buy-active'); // Replace 'add-active' with your desired class name
//                 button2.addClass('add-active'); // Replace 'add-active' with your desired class name
//             } else {
//                 // Remove the class from both buttons
//                 button1.removeClass('buy-active'); // Replace 'add-active' with your desired class name
//                 button2.removeClass('add-active'); // Replace 'add-active' with your desired class name
//             }
//         } else {
//             // If the window width is greater than or equal to 900 pixels, remove the class from both buttons
//             button1.removeClass('buy-active'); // Replace 'add-active' with your desired class name
//             button2.removeClass('add-active'); // Replace 'add-active' with your desired class name
//         }
//     }

//     // Call the function initially
//     checkWindowSize();

//     // Add an event listener to the window's resize event
//     $(window).resize(function () {
//         // Re-check the window size when the window is resized
//         checkWindowSize();
//     });

//     // Add an event listener to the window's scroll event
//     $(window).scroll(function () {
//         // Re-check the window size when the user scrolls
//         checkWindowSize();
//     });
// });
